<div class="app-main__inner">

  <!-- ── Toolbar ────────────────────────────────────────────────────────────── -->
  <div class="rpr-toolbar">
    <div class="rpr-presets">
      <button class="rpr-preset-btn" [class.active]="preset === 'today'"     (click)="setPreset('today')">Today</button>
      <button class="rpr-preset-btn" [class.active]="preset === 'yesterday'" (click)="setPreset('yesterday')">Yesterday</button>
      <button class="rpr-preset-btn" [class.active]="preset === 'month'"     (click)="setPreset('month')">This Month</button>
      <button class="rpr-preset-btn" [class.active]="preset === 'custom'"    (click)="setPreset('custom')">Custom</button>
    </div>
    <ng-container *ngIf="preset === 'custom'">
      <input type="date" class="form-control form-control-sm rpr-tb-date" [(ngModel)]="customFrom" />
      <span class="rpr-tb-sep">to</span>
      <input type="date" class="form-control form-control-sm rpr-tb-date" [(ngModel)]="customTo" />
      <button class="btn btn-primary btn-sm rpr-go-btn" (click)="load()">Go</button>
    </ng-container>
  </div>

  <div *ngIf="error" class="alert alert-danger py-2 mb-2">{{ error }}</div>

  <div *ngIf="loading" class="rpr-loading">
    <div class="spinner-border text-primary"></div>
    <span>Loading transactions...</span>
  </div>

  <!-- ── Table ─────────────────────────────────────────────────────────────── -->
  <ng-container *ngIf="loaded && !loading">
    <div *ngIf="!records.length" class="rpr-empty">No transactions found for the selected period.</div>
    <vio-table-v2 *ngIf="records.length" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
  </ng-container>

</div>
